const t = {
  display: "display",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  subtitle1: "subtitle1",
  subtitle1SemiBold: "subtitle1SemiBold",
  subtitle1Bold: "subtitle1Bold",
  subtitle2Light: "subtitle2Light",
  subtitle2: "subtitle2",
  subtitle2SemiBold: "subtitle2SemiBold",
  subtitle2Bold: "subtitle2Bold",
  subtitle3Light: "subtitle3Light",
  subtitle3: "subtitle3",
  subtitle3SemiBold: "subtitle3SemiBold",
  subtitle3Bold: "subtitle3Bold",
  subtitle4Light: "subtitle4Light",
  subtitle4: "subtitle4",
  subtitle4Italic: "subtitle4Italic",
  subtitle4SemiBold: "subtitle4SemiBold",
  subtitle4Bold: "subtitle4Bold",
  body1: "body1",
  body1Italic: "body1Italic",
  body1SemiBold: "body1SemiBold",
  body1Bold: "body1Bold",
  body1ExtraBold: "body1ExtraBold",
  body2: "body2",
  body2Italic: "body2Italic",
  body2SemiBold: "body2SemiBold",
  body2Bold: "body2Bold",
  body2ExtraBold: "body2ExtraBold",
  caption1: "caption1",
  caption1SemiBold: "caption1SemiBold",
  caption1Bold: "caption1Bold",
  caption1ExtraBold: "caption1ExtraBold",
  caption2: "caption2",
  caption2SemiBold: "caption2SemiBold",
  caption2Bold: "caption2Bold",
  caption2ExtraBold: "caption2ExtraBold",
  caption3Bold: "caption3Bold",
  caption3ExtraBold: "caption3ExtraBold"
};
export {
  t as TYPOGRAPHY_VARIANT
};
//# sourceMappingURL=typography.es.js.map
